import React from 'react';
import './GrcContent.css';
import GRCIMG from '../../assets/images/GRC.png'; 

const GrcContent = () => {
  return (
    <section className="grc-page-content-section">
      <div className="container">
        {/* Top Intro Section */}
        <div className="grc-intro-grid">
          <div className="grc-intro-image-container">
            <img 
              src={GRCIMG}
              alt="SAP GRC" 
              className="grc-intro-image"
            />
          </div>
          <div className="grc-intro-text">
            <h2 className="grc-intro-title">Why Choose Our SAP GRC Consulting Services?</h2>
            <p>
              Looking for SAP GRC Consulting Services UAE in the UAE or SAP GRC Implementation Services USA Our expert team offers specialized solutions to ensure seamless governance, risk, and compliance management. As one of the Best SAP GRC Consulting Firms USA, we deliver services to help you optimize your SAP GRC frameworks. Our SAP Governance Risk and Compliance USA solutions empower your business to navigate complex risks and compliance requirements.
            </p>
          </div>
        </div>

        {/* Features Grid Section */}
        <div className="grc-features-grid">
          <div className="grc-feature-card">
            <h3>SAP GRC Implementation Services for Business</h3>
            <p>
              In today’s fast-paced business environment, effective governance, risk management, and compliance (GRC) practices are essential for maintaining operational integrity and safeguarding an organization’s assets.
            </p>
          </div>
          <div className="grc-feature-card">
            <h3>Gain Expertise with SAP Governance, Risk, and Compliance</h3>
            <p>
              To effectively implement and manage SAP GRC solutions, professionals must be well-trained in the platform’s capabilities. SAP Governance, Risk, and Compliance provide individuals with a solid foundation in the critical principles of GRC.
            </p>
          </div>
          <div className="grc-feature-card">
            <h3>Learn at Your Own Pace with the Best SAP GRC Courses Online</h3>
            <p>
              For those looking to develop their expertise in SAP GRC but require a flexible learning schedule, Best SAP GRC Courses Online offer a perfect solution. These online courses allow you to learn independently and gain in-depth knowledge of SAP GRC without on-site.
            </p>
          </div>
          <div className="grc-feature-card">
            <h3>SAP GRC Services in India</h3>
            <p>
              For those based in India, SAP GRC Services in India offers a convenient and accessible way to gain expertise in SAP’s governance, risk, and compliance solutions. These courses cater to Indian professionals looking to enhance their skills in managing risk and ensuring regulatory compliance.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GrcContent;
